import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import { postRequest, putRequest, getRequest, deleteRequest, uploadPostRequest } from './utils/api'
import { initMenu } from './utils/menus'
import { downloadRequest, postDownloadRequest } from './utils/download'
import tinymce from 'tinymce'
import VueTinymce from '@packy-tang/vue-tinymce'

Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下
Vue.use(VueTinymce)              // 安装vue的tinymce组件

import VuevideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VuevideoPlayer)

import global from './views/Global'// 引用文件
Vue.prototype.GLOBAL = global// 挂载到Vue实例上面


Vue.use(ElementUI, { size: 'small' })
// 插件
Vue.prototype.postRequest = postRequest
Vue.prototype.putRequest = putRequest
Vue.prototype.getRequest = getRequest
Vue.prototype.deleteRequest = deleteRequest
Vue.prototype.uploadPostRequest = uploadPostRequest
Vue.config.productionTip = false
Vue.prototype.downloadRequest = downloadRequest
Vue.prototype.postDownloadRequest = postDownloadRequest

router.beforeEach((to, from, next) => {
    if (window.sessionStorage.getItem('tokenStr')) {
        initMenu(router, store)
        if (!window.sessionStorage.getItem('user')) {
            // 判断用户信息是否存在
            return getRequest('/info').then(resp => {
                if (resp) {
                    // 存入用户信息
                    window.sessionStorage.setItem('user', JSON.stringify(resp))
                    store.commit('initUser', resp)
                    next()
                }
            })
        }
        next()
    } else {
        console.info(router.options.routes)
        if (to.path === '/login') {
            next()
        } else {
            console.info('redirect')
            // next('/？redirect=' + to.path)
            next()
        }
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
